<template>
  <!-- TIME REPORT -->
  <v-flex class="section-1 general-bg" ma-0 pt-4 px-4>        
    <h3 class="text-xs-left pt-2">Exceso de Velocidad</h3>
    <h4 class="text-xs-left pt-2">Reporte por Vehículo</h4>
    <v-layout>
      <!-- SEARCH VEHICLE -->
      <v-flex class="section-left" mt-3 px-1 pb-2>
        <v-text-field
          ref="search"
          v-model="searchVehicleValue"
          flat
          box
          prepend-inner-icon="search"
          color="white"
          label="Código/Sigla ó Placa"
          @keyup.enter="searchVehicle"
          @change="searchVehicle">
        </v-text-field>
        <v-flex v-if="showOk">
          <v-icon color="green">check_circle</v-icon> Vehículo Disponible
        </v-flex>
        <v-flex v-else-if="showStop">
          <v-icon color="red">not_interested</v-icon> Vehículo No Disponible
        </v-flex>
        <!-- INTERVAL -->
        <v-flex v-if="showOk" pt-4>
          <h4>Intervalo <span class="caption">(máximo: 48 Horas)</span></h4>
          <v-flex class="caption-1">Hora(s) : Minutos(s)</v-flex>
          <h4>{{ amountInterval }}</h4>
        </v-flex>
        <!-- MIN VALUES -->
        <v-flex v-if="showOk" py-3>
          <v-flex>
            <v-subheader class="pt-0 pl-0">Velocidad Mínima del Exceso (Km/h)</v-subheader>
            <v-slider
              v-model="minSpeed"
              :max="250"
              :min="60"
              always-dirty
              persistent-hint
              thumb-label="always"
              thumb-size="24"
              prepend-inner-icon="speed"
            ></v-slider>
          </v-flex>
          <v-flex class="min-speed-style">
            <v-subheader class="pt-0 pl-0">Tiempo Mínimo del Exceso (seg)</v-subheader>
            <v-text-field
              v-model="minTime"
              label="Tiempo Mínimo"
              placeholder="Tiempo en segundos"
              type="number"
              :min="minTimeValue"
              :max="maxTimeValue"
              prepend-inner-icon="av_timer"
              hide-details
              box
              color="white"
              @change="minTimeProcess"
            />
          </v-flex>
        </v-flex>
      </v-flex>
      <!-- DATE & TIME -->
      <v-flex d-flex class="section-right" mt-3 ml-4 v-if="showOk">
        <!-- DATE INTERVAL FOR DATE1 -->
        <v-flex class="section-right-in" xs6 mr-3>
          <v-flex>
            <v-menu
              lazy
              ref="menu1"
              v-model="menu1"
              transition="scale-transition"
              :close-on-content-click="false"
              :return-value.sync="dates1"
              offset-x
              left
              full-width
              origin="top left"
              nudge-right="300"
              nudge-top="-40"
              color="white">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="dates1"
                  multiple
                  chips
                  small-chips
                  box
                  label="Escoger el día inicial"
                  prepend-inner-icon="event"
                  readonly
                  color="white"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker
                v-model="dates1"
                multiple
                no-title
                scrollable
                :first-day-of-week="1"
                locale="es-sp"
                :allowed-dates="allowedDates1"
                color="blue accent-3"
                @input="changesOnDate1"
              >
                <v-spacer></v-spacer>
                <v-btn color="error" @click="menu1 = false">Cancelar</v-btn>
                <v-btn color="primary" @click="$refs.menu1.save(dates1)">Aceptar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <!-- SELECT TIMES DATE 1-->
          <v-flex v-if="dates1.length > 0">
            <!-- TIME 1 DATE 1 -->
            <v-flex class="container-date-1" py-2 d-inline-flex px-5 align-center>
              <v-flex>
                <v-icon>event</v-icon>
              </v-flex>
              <v-flex pl-1>
                Fecha Inicial:
              </v-flex>
              <v-flex class="style-date-h" pl-2>
                {{ dates1[0] | moment("DD/MM/YYYY") }}
              </v-flex>
            </v-flex>
            <!-- MENU TIME 1 DATE 1 -->
            <v-flex mt-3>
              <v-menu
                ref="time1Date1Menu"
                class="mx-1"
                lazy
                :close-on-content-click="false"
                v-model="time1Date1Menu"
                transition="scale-transition"
                offset-x
                left
                full-width
                allow-overflow
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :return-value.sync="time1Date1"
              >
                <v-text-field
                  slot="activator"
                  label="Hora Inicial"
                  placeholder="Seleccionar Hora"
                  v-model="time1Date1"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable
                />
                <v-time-picker
                  landscape
                  v-model="time1Date1"
                  format="24hr"
                  scrollable
                  color="teal darken-1"
                  header-color="grey darken-4"
                  @input="changesOnTime1Date1"
                >
                  <!-- @change="$refs.time1Date1Menu.save(time1Date1)" -->
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time1Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="$refs.time1Date1Menu.save(time1Date1)">Aceptar</v-btn>
                </v-time-picker>
              </v-menu>
            </v-flex>
            <!-- TIME 2 DATE 1 MENU -->
            <v-flex v-if="time1Date1 !== null && dates2.length === 0" mt-3>
              <v-menu
                ref="time2Date1Menu"
                class="mx-1"
                lazy
                :close-on-content-click="false"
                v-model="time2Date1Menu"
                transition="scale-transition"
                offset-x
                left
                full-width
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :return-value.sync="time2Date1">
                <v-text-field
                  slot="activator"
                  label="Hora Final"
                  placeholder="Seleccionar Hora"
                  v-model="time2Date1"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable/>
                <v-time-picker
                  landscape
                  v-model="time2Date1"
                  format="24hr"
                  scrollable
                  :allowed-hours="allowedHours0"
                  :allowed-minutes="allowedMinutes0"
                  color="red darken-1"
                  header-color="grey darken-4">
                  <!-- @change="$refs.time2Date1Menu.save(time2Date1)" -->
                  <v-spacer></v-spacer>
                  <v-btn color="error" @click="time2Date1Menu = false">Cancelar</v-btn>
                  <v-btn color="primary" @click="$refs.time2Date1Menu.save(time2Date1)">Aceptar</v-btn>
                </v-time-picker>

              </v-menu>
            </v-flex>
          </v-flex>
        </v-flex>
        <!-- ////////////////////////////////////////////////////////// -->
        <!-- DATE INTERVAL FOR DATE2 -->
        <!-- ////////////////////////////////////////////////////////// -->
        <v-flex class="section-right-in"  v-if="time1Date1 !== null && dates1.length > 0" xs6 ml-3>
          <v-flex>
            <v-menu
              lazy
              ref="menu2"
              v-model="menu2"
              transition="scale-transition"
              :close-on-content-click="false"
              :return-value.sync="dates2"
              offset-x
              left
              full-width
              origin="top left"
              nudge-right="300"
              nudge-top="-40"
              color="white">
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="dates2"
                  multiple
                  chips
                  small-chips
                  box
                  label="Escoger el día final"
                  prepend-inner-icon="event"
                  readonly
                  color="white"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker 
                v-model="dates2"
                multiple
                no-title
                scrollable
                :first-day-of-week="1"
                locale="es-sp"
                :allowed-dates="allowedDates2"
                color="blue accent-3"
                @input="changesOnDate2"
              >
                <v-spacer></v-spacer>
                <v-btn color="error" @click="menu2 = false">Cancelar</v-btn>
                <v-btn color="primary" @click="$refs.menu2.save(dates2)">Aceptar</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <!-- SELECT TIME DATE 2-->
          <v-flex v-if="!!dates2[0]">
            <!-- TIME 1 DATE 2 -->
            <v-flex class="container-date-2" py-2 d-inline-flex px-5 align-center>
              <v-flex>
                <v-icon>event</v-icon>
              </v-flex>
              <v-flex pl-1>
                Fecha Final:
              </v-flex>
              <v-flex class="style-date-h" pl-2>
                {{ dates2[0] | moment("DD/MM/YYYY") }}
              </v-flex>
            </v-flex>
            <!-- MENU TIME 1 DATE 2 -->
            <v-flex mt-3>
              <v-menu
                ref="time1Date2Menu"
                class="mx-1"
                lazy
                :close-on-content-click="false"
                v-model="time1Date2Menu"
                transition="scale-transition"
                offset-x
                left
                full-width
                allow-overflow
                min-width="290px"
                origin="top left"
                nudge-right="750"
                nudge-bottom="0"
                :return-value.sync="time1Date2">
                <v-text-field
                  slot="activator"
                  label="Hora Final"
                  placeholder="Seleccionar Hora"
                  v-model="time1Date2"
                  prepend-inner-icon="av_timer"
                  readonly
                  box
                  hide-details
                  color="white"
                  clearable/>
                <v-time-picker
                  landscape
                  v-model="time1Date2"
                  format="24hr"
                  scrollable
                  color="red darken-1"
                  header-color="grey darken-4"
                  :allowed-hours="allowedHours1"
                  :allowed-minutes="allowedMinutes1"
                >
                  <!-- @change="$refs.time1Date2Menu.save(time1Date2)" -->
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-center">
                    <v-btn color="error" @click="time1Date2Menu = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="$refs.time1Date2Menu.save(time1Date2)">Aceptar</v-btn>
                  </v-flex>
                </v-time-picker>
              </v-menu>
            </v-flex> 
          </v-flex>
        </v-flex>
      </v-flex>
    </v-layout>
    <!-- BUTTON -->
    <v-flex class="text-xs-center" my-5 pb-3 v-if="showOk">
        <!-- :href="urlReportPoint" -->
      <v-btn
        v-if="!reportReadyGSVR"
        :disabled="reportTimeDisabled"
        target="_blank"
        color="primary"
        @click="downloadSpeedVehicleReport"
        :loading="$loading.isLoading('generatingSpeedVehicleReport')">
        <v-icon left>description</v-icon>
        Generar Reporte
      </v-btn>
      <v-btn
        v-if="reportReadyGSVR"
        :href="urlReportGSVR"
        target="_blank"
        color="success"
        @click="toggleBtnGSVR(false)"
      >
        <v-icon left>cloud_download</v-icon>
        Descargar Reporte
      </v-btn>
    </v-flex>
  </v-flex>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'report-by-speed-vehicle',
    data() {
      return {
        minTimeValue: 8,
        maxTimeValue: 32400,
        minTime: 8,
        minSpeed: 60,
        time1Date2: null,
        time1Date2Menu: false,
        time2Date1: null,
        time2Date1Menu: false,
        time1Date1Menu: false,
        time1Date1: null,
        menu1: false,
        menu2: false,
        dates1: [],
        dates2: [],
        showOk: false,
        showStop: false,
        searchVehicleResult: [],
        searchAction: false,
        searchVehicleValue: null
      }
    },
    computed: {
      ...mapGetters(['reportReadyGSVR', 'urlReportGSVR']),
      amountInterval() {
        let value = 0
        const date1 = this.$moment(`${this.dates1[0]} ${this.time1Date1}`)
        if (this.time1Date1 !== null && this.time2Date1 !== null) {
          const date2 = this.$moment(`${this.dates1[0]} ${this.time2Date1}`)
          value = Math.abs(date2.diff(date1, 'minutes'))
        } else if (this.dates2.length === 1 && this.time1Date2 !== null) {
          const date2 = this.$moment(`${this.dates2[0]} ${this.time1Date2}`)
          value = Math.abs(date2.diff(date1, 'minutes'))
        }
        const hours = Math.floor(value / 60)
        const minutes = value % 60
        return `${hours} : ${minutes}`
      },
      reportTimeDisabled() {
        let result = true
        if (this.dates1.length === 1 && this.dates2.length === 0 && this.time1Date1 && this.time2Date1) result = false
        else if (this.dates2.length === 1 && this.time1Date1 && this.time1Date2) result = false
        return result
      }
    },
    methods: {
      ...mapActions([
        'toggleBtnGSVR',
        'getSpeedVehicleReport',
        // 'getTimeReport',
        'searchVehicleAction'
      ]),
      minTimeProcess() {
        // console.log('CHANGE: ', this.minTime)
        if (this.minTime < this.minTimeValue) this.minTime = this.minTimeValue
        else if (this.minTime > this.maxTimeValue) this.minTime = this.maxTimeValue
      },
      allowedMinutes1(value) {
        const initDay = this.$moment(this.dates1[0])
        const finalDay = this.$moment(this.dates2[0])
        const diffHours = Math.abs(finalDay.diff(initDay, 'hours'))
        if (this.time1Date2 !== null) {
          const selectedHour2 = this.time1Date2.split(':')
          const selectedHour1 = this.time1Date1.split(':')
          const hour1 = Number(selectedHour1[0])
          const minute1 = Number(selectedHour1[1])
          if (Number(selectedHour2[0]) === hour1 && diffHours > 24) {
            if (value <= minute1) return true
            else return false
          }
        }
        return true
      },
      allowedHours1(value) {
        const initDay = this.$moment(this.dates1[0])
        const finalDay = this.$moment(this.dates2[0])
        const diffHours = Math.abs(finalDay.diff(initDay, 'hours'))
        // console.log('DIFF DAY: ', diffHours, value, this.time1Date1)

        const selectedHour1 = this.time1Date1.split(':')
        let hoursResult
        if (diffHours === 24) hoursResult = true
        else {
          if (this.time1Date2 === null) this.time1Date2 = this.time1Date1
          hoursResult = value <= Number(selectedHour1[0])
        }
        return hoursResult
      },
      changesOnDate1() {
        this.dates2 = []
        this.time1Date1 = null
        this.time1Date2 = null
      },
      changesOnDate2() {
        // console.log('changesOnDate2')
        this.time2Date1 = null
      },
      allowedDates2(date) {
        let today = this.$moment.now()
        today = this.$moment(today).format('YYYY-MM-DD')
        // console.log('TODAY: ', today)
        // console.log('DATES 1: ', this.dates1[0])
        if (today === this.dates1[0]) return false

        const selectedDate = this.$moment(this.dates1[0])
        const differenceTime = Math.abs(selectedDate.diff(today, 'hours'))
        // console.log('DIFF TODAY: ', differenceTime)

        const addDay = differenceTime <= 24 ? 1 : 2
        // console.log('ADD DAY: ', addDay)

        let datesResult
        if (addDay === 1 && date === today) datesResult = true
        else if (addDay === 2) {
          if (this.dates2.length === 1) {
            datesResult = date === this.dates2[0]
          } else {
            const dayAfter1 = this.$moment(this.dates1[0]).add(1, 'days').format('YYYY-MM-DD')
            const dayAfter2 = this.$moment(this.dates1[0]).add(2, 'days').format('YYYY-MM-DD')
            datesResult = date === dayAfter1 || date === dayAfter2
          }
        }
        return datesResult
      },
      allowedMinutes0(value) {
        // console.log('allowedMinutes0: ', value, this.time2Date1)
        if (this.time2Date1 !== null) {
          const selectedHour2 = this.time2Date1.split(':')
          const selectedHour1 = this.time1Date1.split(':')
          const hour1 = Number(selectedHour1[0])
          const minute1 = Number(selectedHour1[1])
          if (Number(selectedHour2[0]) === hour1) {
            if (value > minute1) return true
            else return false
          }
        }
        return true
      },
      changesOnTime1Date1() {
        // console.log('changeOnTime1Date1')
        this.time2Date1 = null
      },
      allowedHours0(value) {
        if (this.time2Date1 === null) this.time2Date1 = this.time1Date1
        const myDate = `${this.dates1[0]} ${this.time1Date1}`
        const selectedHour1 = this.time1Date1.split(':')
        const amountOfHours = 24 - Number(selectedHour1[0])
        // console.log('AMOUNT OF HOURS:', amountOfHours)
        const allowedHoursArray = []
        for (let i = 0; i < amountOfHours; i++) {
          const h = this.$moment(myDate).add(i, 'hours').format('H')
          allowedHoursArray.push(Number(h))
        }
        const isIn = allowedHoursArray.filter(item => item === value)
        // console.log('IS IN: ', isIn)
        if (isIn.length > 0) {
          // console.log('VALUE: ', value)
          return true
        } else return false
      },
      downloadSpeedVehicleReport() {
        const payload = {
          id: this.searchVehicleResult[0].id,
          date1: this.dates1[0],
          time1Date1: this.time1Date1,
          time2Date1: this.time2Date1,
          date2: this.dates2[0] ? this.dates2[0] : null,
          time1Date2: this.time1Date2,
          duration: this.minTime,
          limit: this.minSpeed
        }
        // console.log('DOWNLOAD SPEED VEHICLE REPORT: ', payload)
        this.getSpeedVehicleReport(payload)
      },
      allowedDates1(date) {
        let today = this.$moment.now()
        let datesResult = this.$moment(date).isBefore(today)
        today = this.$moment(today).format('YYYY-MM-DD')

        if (this.dates1.length === 1) datesResult = date === this.dates1[0]

        return datesResult
      },
      searchVehicle() {
        // console.log('SEARCH', this.searchVehicleValue)
        if (this.searchVehicleValue !== null) {
          this.searchAction = false
          this.searchVehicleAction(this.searchVehicleValue)
            .then(result => {
              // this.searchVehicleValue = null
              this.searchAction = true
              // this.$refs.search.reset()
              this.searchVehicleResult = result
              // console.log('searchVehicleResult ', this.searchVehicleResult)
              if (this.searchVehicleResult.length > 0) {
                this.showOk = true
                this.showStop = false
              } else {
                this.showOk = false
                this.showStop = true
              }
              // console.log('RESULT', this.searchVehicleResult)
            })
        }
      }
    }
  }
 </script>
 
 <style lang="stylus" scoped>
h3
  font-size 30px
  font-weight 500
  line-height 7px

h4
  font-size 21px
  font-weight 500

.min-speed-style
  margin-top -20px

.caption-1
  font-size 9px
  font-weight 500

.section-right-in
  min-width 325px
  max-width 325px

.section-right
  min-width max-content
  

.section-left
  // min-width max-content
  min-width 270px
  max-width 270px

.section-1
  min-width max-content
  // max-width 1000px
  
.general-bg
  background-color #424242
  border-radius 3px

.style-date-h
  font-weight 600
  font-size 16px

.container-date-1
  background-color #00897B
  border-radius 30px

.container-date-2
  background-color #E53935
  border-radius 30px
 </style>


// WEBPACK FOOTER //
// src/components/Reports/ReportBySpeedVehicle.vue